import { Box, Checkbox } from "@mui/material";
import { KeyDriveBodyMax } from "../../../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";

interface IRuleCard {
    text: string;
    checked: boolean;
    onChange?: ((event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void) | undefined;
}

export function RuleCard({
    text,
    checked,
    onChange
}: IRuleCard) {
    return (
        <Box
            width="615px"
            display="flex"
            alignItems="center"
            gap={1}
            border="1px solid #D3E0E8"
            borderRadius="4px"
        >
            <Checkbox 
                onChange={onChange}
                checked={checked}        
            />
            <KeyDriveBodyMax 
                color="#22638D"
                needBold
                needEllipses={false}
                text={text}
            />
        </Box>
    )
}